import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const HIDE_PORTFOLIO_VALUE_KEY = "cur8:hidePortfolioValue";

const readPersistedHide = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(HIDE_PORTFOLIO_VALUE_KEY) === "true";
  } catch {
    return false;
  }
};

export interface UiPreferencesState {
  hidePortfolioValue: boolean;
}

export const INITIAL_STATE: UiPreferencesState = {
  hidePortfolioValue: readPersistedHide(),
};

const uiPreferencesSlice = createSlice({
  name: "uiPreferences",
  initialState: INITIAL_STATE,
  reducers: {
    setHidePortfolioValue: (state, action: PayloadAction<boolean>) => {
      state.hidePortfolioValue = action.payload;
    },
  },
});

export const { setHidePortfolioValue } = uiPreferencesSlice.actions;

export default uiPreferencesSlice.reducer;
